import { createTheme } from '@mui/material'

import colors from './colors.json'
import components from './components.json'
import typography from './typography.json'

const lightThemePalette = {
    primary: { main: colors.magenta['400'] },
    neutral: {
        main: colors.gray['800'],
        contrastText: colors.gray['100'],
    },
}

export const lightTheme = createTheme({
    palette: {
        ...colors,
        ...lightThemePalette,
    },
    typography: {
        ...typography,
        button: {
            // buttons are all caps by default
            textTransform: 'none',
        },
    },
    components: {
        ...components,
    },
})

export const theme = lightTheme
